import get from 'lodash/get';
import RavenUtils from '../utils/raven';

// eslint-disable-next-line no-unused-vars
const errorLogMiddleware = store => next => action => {
  const isFailedAction = action.type.slice(-6) === 'FAILED';
  const error = action.error || action.payload;
  const isApiError = error && error.name && error.name.match(/Api.+Error/);

  if (isFailedAction && !isApiError) {
    const configState = store.getState().config;
    const config = {
      release: get(configState, ['env', 'version']),
      environment: get(configState, ['env', 'environment']),
      appEnvironment: get(configState, ['env', 'appEnvironment']),
      hostname: get(configState, ['env', 'hostname']),
    };
    const key = get(configState, ['client', 'sentryPublicKey']);

    RavenUtils.reportError(error, key, config);
  }

  return next(action);
};

export default errorLogMiddleware;



// WEBPACK FOOTER //
// ./app/middlewares/errorLog.js